import { render } from "./selectVillageModal.vue?vue&type=template&id=7e5e9cce&ts=true"
import script from "./selectVillageModal.vue?vue&type=script&lang=ts"
export * from "./selectVillageModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__